import React from "react";
import "./RowMode.css";
import { IReducer } from "../../state/reducer";
import { ActionType } from "../../state/action";

interface RowModeProps extends IReducer {
  rowType: ActionType;
}

export const RowMode: React.FC<RowModeProps> = ({
  state,
  dispatch,
  rowType,
}) => {
  const renderCheckedType = () => {
    if (rowType === "TOGGLE_USE_ACTION_ROWS") {
      return state?.useActionRows ?? false;
    }

    if (rowType === "TOGGLE_USE_INVENTORY_ROWS") {
      return state?.useInventoryRows ?? false;
    }

    return false;
  };

  return (
    <div className="rowMode">
      <div className="rowModeText">Use rows</div>
      <input
        type="checkbox"
        checked={renderCheckedType()}
        onChange={(e) =>
          dispatch({
            type: rowType,
            rowChange: e.target.checked,
          })
        }
      />
    </div>
  );
};
